﻿module.exports = function ($) {
    return {
        init: function () {
            var meTermsAndConditions = $(".meTermsAndConditions").length > 0;
            if (meTermsAndConditions)
                this.bindEvents();
        },
        bindEvents: function () {
            $('.meTermsAndConditions #submitAgree').on('click', function (e) {
                $('#meAgreeValidationMsg').hide();
                $('#meAgreeErrorMsg').hide();
                var agreed = $('#meAgree:checked').length >= 1;
                if(!agreed)
                {
                    // Show error msg
                    console.log("error: not checked");
                    $('#meAgreeValidationMsg').show();
                    return;
                }

                // Send agree flag to api.
                $.ajax({
                    url: '/umbraco/surface/medb/AgreedToTerms',
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify({ agreed: agreed }),
                    success: function (data) {
                        if (data.url)
                            window.location = data.url;
                        else
                            $('#meAgreeErrorMsg').show();
                    },
                    error: function (result) {
                        $('#meAgreeErrorMsg').show();
                        console.log(result);
                    },
                    complete: function () {
                        //redirect to search page.
                    }
                });
            });
        }
    }
}